import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';

import translations from './.vocab';

export default function PendingActivationBanner() {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="info">
      <Text>{t('This account has not been activated...')}</Text>
    </Alert>
  );
}
